<script lang="ts">
    interface Props {
        height?: string;
        width?: string;
        strokeColor?: string;
        fillColor?: string;
        hover?: string;
        classList?: string;
    }

    let {
        height = "h-6",
        width = "w-6",
        strokeColor = "stroke-white",
        fillColor = "fill-white",
        hover = "group-hover/btn-emoji:fill-white",
        classList = "aspect-ratio transition-all",
    }: Props = $props();
</script>

<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="{height} {width} {strokeColor} {fillColor} {classList} {hover} icon icon-tabler icons-tabler-filled icon-tabler-man"
>
    <path
        d="M5.9999 8.63965C7.80214 8.63965 9.30317 9.66008 10.4803 11.6451L10.5727 11.8043L10.5916 11.8463L10.6042 11.8812L10.6101 11.9043L10.616 11.9387L10.6206 11.9807V12.0269L10.6147 12.0736C10.612 12.0892 10.6083 12.1046 10.6038 12.1198L10.5874 12.1652L10.5723 12.1967L10.5656 12.2093C9.40442 14.2409 7.91893 15.3096 6.13139 15.3596L5.9999 15.3613C4.15313 15.3613 2.62354 14.2905 1.43422 12.2088C1.39797 12.1454 1.37891 12.0736 1.37891 12.0005C1.37891 11.9274 1.39797 11.8556 1.43422 11.7921C2.62354 9.71049 4.15313 8.63965 5.9999 8.63965ZM5.9999 10.7402C5.66565 10.7402 5.34508 10.8729 5.10873 11.1093C4.87238 11.3457 4.73959 11.6662 4.73959 12.0005C4.73959 12.3347 4.87238 12.6553 5.10873 12.8916C5.34508 13.128 5.66565 13.2608 5.9999 13.2608C6.33416 13.2608 6.65472 13.128 6.89107 12.8916C7.12743 12.6553 7.26021 12.3347 7.26021 12.0005C7.26021 11.6662 7.12743 11.3457 6.89107 11.1093C6.65472 10.8729 6.33416 10.7402 5.9999 10.7402Z"
    />
    <path
        d="M17.9999 8.63965C19.8021 8.63965 21.3032 9.66008 22.4803 11.6451L22.5727 11.8043L22.5916 11.8463L22.6042 11.8812L22.6101 11.9043L22.616 11.9387L22.6206 11.9807V12.0269L22.6147 12.0736C22.612 12.0892 22.6083 12.1046 22.6038 12.1198L22.5874 12.1652L22.5723 12.1967L22.5656 12.2093C21.4044 14.2409 19.9189 15.3096 18.1314 15.3596L17.9999 15.3613C16.1531 15.3613 14.6235 14.2905 13.4342 12.2088C13.398 12.1454 13.3789 12.0736 13.3789 12.0005C13.3789 11.9274 13.398 11.8556 13.4342 11.7921C14.6235 9.71049 16.1531 8.63965 17.9999 8.63965ZM17.9999 10.7402C17.6656 10.7402 17.3451 10.8729 17.1087 11.1093C16.8724 11.3457 16.7396 11.6662 16.7396 12.0005C16.7396 12.3347 16.8724 12.6553 17.1087 12.8916C17.3451 13.128 17.6656 13.2608 17.9999 13.2608C18.3342 13.2608 18.6547 13.128 18.8911 12.8916C19.1274 12.6553 19.2602 12.3347 19.2602 12.0005C19.2602 11.6662 19.1274 11.3457 18.8911 11.1093C18.6547 10.8729 18.3342 10.7402 17.9999 10.7402Z"
    />
</svg>
